import { useEffect, useState } from 'react';
import { useSelector, history } from 'umi';
import { fetchFollowingUnifiedId } from '@/pages/intelligence/services/following';
import { IS_GLOBAL } from '@/pages/home/_config/config';

interface IfollowList {
  company_data: string[];
  console_new_data: string[];
  console_old_data: string[];
  mobile_new_data: string[];
  mobile_old_data: string[];
  // ogdb_data: string[];
  pc_new_data: string[];
  pc_old_data: string[];
}

//Following展示卡片的优先级，按下面顺序
const followBasicData = IS_GLOBAL ? [
  'pc_old_data',//默认pc优先
  'mobile_old_data',
  // 'ogdb_data',
  'console_old_data',
  'pc_new_data',
  'mobile_new_data',
  'console_new_data',
  'company_data',
] : [
  'mobile_old_data',//默认mobile优先
  'pc_old_data',
  // 'ogdb_data',
  'console_old_data',
  'mobile_new_data',
  'pc_new_data',
  'console_new_data',
  'company_data',
];


const getNewFollowUrlGamepath = (type: string) => {
  //将页签转为跳转的路径---新情报跳转
  const gamePathMap = {
    mobile_old_data: 'currentgames_mobile',
    // ogdb_data: 'currentgames_mobile',
    pc_old_data: 'currentgames_pc',
    console_old_data: 'currentgames_console',
    mobile_new_data: 'newgames_mobile',
    pc_new_data: 'newgames_pc',
    console_new_data: 'newgames_console',
    company_data: 'currentgames_company',
  } as any;

  return gamePathMap[type];
};

const defaultFollowingPath = IS_GLOBAL ? 'currentgames_pc' : 'currentgames_mobile';
const defaultItlPath = IS_GLOBAL ? `/intelligence/topCharts/pcGames` : `/intelligence/topCharts/mobileGames`;

//firstFollowSegement为空时默认跳转到PC榜单，不为空时则跳转到Following对应的路径
export const jumpDbiDefaultPage = (firstFollowSegement?: string) => {
  const newFollowingPage = `/intelligence/following/${getNewFollowUrlGamepath(
    firstFollowSegement || defaultFollowingPath,
  )}`;
  //默认跳转到情报PC-Topcharts
  const newUrl = firstFollowSegement ? newFollowingPage : defaultItlPath;

  history.push(newUrl);
};

interface FolloingModelType {
  isgetData: boolean; //是否调用接口
  setIsUpdateBasicInfo?: (val: boolean) => void
}

function isEmptyObject(obj: any) {
  // 遍历对象的所有键，检查其中是否存在一个非空的值
  //接口改为返回bool值
  return !Object.keys(obj).some((key) => obj[key]/* && obj[key].length > 0*/);
}

/** 获取当前标签的关注列表 */
const transFollowUidsToTabFommat = (list: IfollowList) => {
  //处理如果没数据则返回Null
  const resultIsEmpty = isEmptyObject(list);
  if (resultIsEmpty) {
    return null;
  }
  return {
    // ogdb_data: list?.ogdb_data ?? null,
    currentgames_mobile: list?.mobile_old_data ?? null,
    currentgames_pc: list?.pc_old_data ?? null,
    currentgames_console: list?.console_old_data ?? null,
    currentgames_company: list?.company_data ?? null,
    newgames_mobile: list?.mobile_new_data ?? null,
    newgames_pc: list?.pc_new_data ?? null,
    newgames_console: list?.console_new_data ?? null,
  };
};

/**
 * useFollowingUnifiedIdModel 是一个自定义hook，用于获取用户关注游戏的统一ID。
 * 返回值包括：
 *   - 是否正在加载数据 (loading)
 *   - 是否出现错误 (error)
 *   - 用户关注游戏的统一ID集合 (unifiedIds)
 *   - 用户首个关注游戏的分类路径 (firstFollowSegement)
 * 由于用户随时可能收藏或取消关注，并且不将此API放在model中作为单次请求，因此需要返回loading。
 */
const useFollowingUnifiedIdModel = (props: FolloingModelType) => {
  const { isgetData, setIsUpdateBasicInfo } = props;
  const { userInfo } = useSelector((state) => {
    // @ts-ignore
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  // 用于在头部菜单中确定跳转到哪个页面，如果没有关注的游戏则跳转到手游榜单
  const [firstFollowSegement, setFirstFollowSegement] = useState('');
  const [unifiedIds, setUnifiedIds] = useState<any>(null);
  const [hasFollowData, setHasFollowData] = useState<any>(false);

  useEffect(() => {
    // if (isgetData && userInfo?.userid) {
    if (isgetData && userInfo?.userid) {
      getFollowingInfo();
      setIsUpdateBasicInfo?.(false);
    }
  }, [isgetData, userInfo?.userid]);

  /**
   * getFollowingInfo 函数发送异步请求，从API获取关注游戏的统一ID，
   * 并确定首个关注游戏的分类路径。
   */
  const getFollowingInfo = async () => {
    try {
      const res = await fetchFollowingUnifiedId({
        // users_id: userInfo?.userid,
      });

      const gamepath = followBasicData.find((item) => res?.data?.[item]) || '';

      // 更新状态，设置统一ID集合、首个关注游戏分类路径、加载状态和错误状态
      const fommatIds = transFollowUidsToTabFommat(res?.data);
      setUnifiedIds(fommatIds);
      setHasFollowData(fommatIds !== null);
      setFirstFollowSegement(gamepath);
      setLoading(false);
      setError(false);
    } catch (err: any) {
      setUnifiedIds(null);
      setHasFollowData(true);
      setFirstFollowSegement('');
      setLoading(false);
      setError(true);
    }
  };

  return {
    loading,
    error,
    firstFollowSegement,
    hasFollowData /**是否有关注数据 */,
    unifiedIds,
  };
};

export default useFollowingUnifiedIdModel;
